import { render } from "./HeroiconsOutlineFilm.vue?vue&type=template&id=a5cc6a6e"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFilm.vue"]])

export default __exports__